var L = Object.defineProperty, J = Object.defineProperties;
var z = Object.getOwnPropertyDescriptors;
var C = Object.getOwnPropertySymbols;
var D = Object.prototype.hasOwnProperty, F = Object.prototype.propertyIsEnumerable;
var v = (e, t, i) => t in e ? L(e, t, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[t] = i, p = (e, t) => {
  for (var i in t || (t = {}))
    D.call(t, i) && v(e, i, t[i]);
  if (C)
    for (var i of C(t))
      F.call(t, i) && v(e, i, t[i]);
  return e;
}, E = (e, t) => J(e, z(t));
var T = (e, t, i) => v(e, typeof t != "symbol" ? t + "" : t, i);
var P = (e, t, i) => new Promise((r, l) => {
  var B = (f) => {
    try {
      b(i.next(f));
    } catch (m) {
      l(m);
    }
  }, s = (f) => {
    try {
      b(i.throw(f));
    } catch (m) {
      l(m);
    }
  }, b = (f) => f.done ? r(f.value) : Promise.resolve(f.value).then(B, s);
  b((i = i.apply(e, t)).next());
});
var y, $;
(function() {
  try {
    var e = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {}, t = new e.Error().stack;
    t && (e._sentryDebugIds = e._sentryDebugIds || {}, e._sentryDebugIds[t] = "25e0a69a-5e8b-400b-afe1-bed8f9c7ea4c", e._sentryDebugIdIdentifier = "sentry-dbid-25e0a69a-5e8b-400b-afe1-bed8f9c7ea4c");
  } catch (i) {
  }
})(), (typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {}).SENTRY_RELEASE = { id: "5f2e02717f0a61fd63cbf534be45f45bbbab73d7" }, function(e) {
  e.Sidebar = "sidebar", e.Searchbar = "searchbar";
}(y || (y = {})), y.Sidebar, y.Searchbar;
class k extends Error {
  constructor(i, r) {
    super(i, r);
    T(this, "cause");
    this.name = "BrainfishWidgetError", this.cause = r == null ? void 0 : r.cause, Error.captureStackTrace && Error.captureStackTrace(this, k), this.cause instanceof Error && this.cause.stack && (this.stack = this.stack + `
Caused by: ` + this.cause.stack);
  }
  toJSON() {
    return { name: this.name, message: this.message, stack: this.stack, cause: this.cause instanceof Error ? { name: this.cause.name, message: this.cause.message, stack: this.cause.stack } : this.cause };
  }
}
(function(e) {
  e.LINK = "link", e.CALLBACK = "callback", e.EMAIL = "email", e.PHONE = "phone";
})($ || ($ = {}));
const O = (e, t) => {
  if (!navigator || navigator.userAgent.toLowerCase().includes("headless")) return;
  const i = e.toJSON();
  fetch("https://app.brainfi.sh/api/trackError.widget.create", { method: "POST", headers: { "Content-Type": "application/json", "api-key": t }, body: JSON.stringify({ error: e.message, stack: e.stack, cause: { message: i.message, stack: i.stack, cause: i.cause } }) });
}, W = (e, t, i) => {
  let r = t, l = {};
  if (e instanceof Error) try {
    l = JSON.parse(e.message), r += ` - ${l.message || e.message}`;
  } catch (s) {
    r += ` - ${e.message}`;
  }
  else r += ` - ${String(e)}`;
  const B = new k(r, { cause: l });
  O(B, i);
}, x = "https://app.brainfi.sh";
function H(e) {
  return e.map((t) => t.type === $.CALLBACK && t.value ? E(p({}, t), { value: new Function(`return ${t.value}`)() }) : t);
}
const N = (() => {
  if (typeof window == "undefined") return;
  const e = window.navigator.userAgent;
  if (!(e.match(/iPad/i) || e.match(/iPhone/i))) return !1;
  const t = e.match(/OS (\d+)_/i);
  return t && parseInt(t[1], 10) <= 14;
})();
let I = !1;
const j = (e) => P(void 0, null, function* () {
  let { widgetKey: t, overrides: i } = e;
  try {
    const l = `${x}/api/searchWidgets.getConfigByKey`, B = yield function(d, o) {
      return P(this, null, function* () {
        return fetch(d, { method: "POST", headers: { "Content-Type": "application/json", "api-key": o } }).then((n) => {
          if (!n.ok) throw new Error(`API call failed with status: ${n.status}`);
          return n.json();
        }).then((n) => {
          if (!n) throw new Error("Error loading config: empty response");
          return n;
        }).catch((n) => {
          O(new k("Error fetching config", { cause: n }), o);
        });
      });
    }(l, t), s = ((d) => {
      var o, n, u;
      let { config: a, apiKey: A } = d;
      return (o = a.settings) !== null && o !== void 0 && o.bodyActionButtons && (a.settings.bodyActionButtons = H(a.settings.bodyActionButtons)), (n = a.settings) !== null && n !== void 0 && n.footerActionButtons && (a.settings.footerActionButtons = H(a.settings.footerActionButtons)), (u = a.settings) !== null && u !== void 0 && u.nextBestActions && (a.settings.nextBestActions = H(a.settings.nextBestActions)), E(p({}, a), { apiHost: `${x}`, widgetMode: a.widgetType, apiKey: A });
    })({ config: B.config, apiKey: t }), b = s.version || "latest";
    if (i) {
      const { nextBestActions: d, bodyActionButtons: o, footerActionButtons: n } = i, u = function() {
        let a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], A = arguments.length > 1 ? arguments[1] : void 0;
        try {
          const h = new Map(a.map((c) => [c.label, c]));
          return A.forEach((c) => h.set(c.label, c)), Array.from(h.values());
        } catch (h) {
          return console.warn(`Error processing actions: overrides: ${JSON.stringify(i)}`, h), [];
        }
      };
      s.settings && (s.settings = E(p({}, s.settings), { nextBestActions: d ? u(s.settings.nextBestActions, d) : s.settings.nextBestActions, bodyActionButtons: o ? u(s.settings.bodyActionButtons, o) : s.settings.bodyActionButtons, footerActionButtons: n ? u(s.settings.footerActionButtons, n) : s.settings.footerActionButtons }));
    }
    const f = `https://cdn.jsdelivr.net/npm/@brainfish-ai/search-widget@${b}/dist/web.js`, m = N ? f.replace("web.js", "web.umd.js") : f;
    let w;
    try {
      yield function(d, o, n) {
        return new Promise((u, a) => {
          if (document.getElementById("brainfish-widget")) return n && n(), u();
          const A = N ? "text/javascript" : "module", h = document.createDocumentFragment(), c = document.createElement("script");
          c.id = "brainfish-widget", c.src = o, c.type = A, c.async = !0, c.onload = () => {
            setTimeout(() => {
              const S = window.Brainfish;
              if (S) n && n(S), u();
              else {
                const g = new Error("Failed to load Brainfish module");
                W(g, "Failed to load script", d), a(g);
              }
            }, 200);
          }, c.onerror = (S) => {
            const g = S, K = { message: `Failed to load script: ${o}`, type: g.type, fileName: g.filename, lineNumber: g.lineno, columnNumber: g.colno, error: g.error ? g.error.toString() : "Unknown error" };
            a(new Error(JSON.stringify(K)));
          }, N || (h.appendChild(c), document.head.appendChild(h));
        });
      }(t, m, (d) => {
        setTimeout(() => {
          I || W(new Error("Widget load failed"), "Widget load failed", t);
        }, 3e3), d ? (w = d, I = !0) : w = window.Brainfish;
        try {
          switch (s.widgetType) {
            case y.Searchbar:
            case "Search":
              w.SearchWidget && w.SearchWidget.initStandard(s);
              break;
            case y.Sidebar:
            case "slide-over":
              w.HelpWidget && w.HelpWidget.initPopup(s);
              break;
            default:
              return;
          }
        } catch (o) {
          W(o, `Error loading widget: ${f}`, t);
        }
      }), _ && w && (r = w, typeof window != "undefined" && (window.Brainfish ? window.Brainfish = p(p({}, window.Brainfish), r) : window.Brainfish = p({}, r)));
    } catch (d) {
      throw new Error(`Error loading widget: ${f}`, { cause: d });
    }
  } catch (l) {
    W(l, l.message, t);
  }
  var r;
}), _ = { Widgets: { init: j }, SearchWidget: { initStandard: (e) => {
  typeof window != "undefined" && (window.Brainfish && window.Brainfish.SearchWidget ? window.Brainfish.SearchWidget.initStandard(e) : console.warn("Brainfish is not initialized. Please call Brainfish.Widgets.init() first."));
} }, HelpWidget: { initPopup: (e) => {
  typeof window != "undefined" && (window.Brainfish && window.Brainfish.HelpWidget ? window.Brainfish.HelpWidget.initPopup(e) : console.warn("Brainfish is not initialized. Please call Brainfish.Widgets.init() first."));
}, close: (e) => {
  typeof window != "undefined" && (window.Brainfish && window.Brainfish.HelpWidget ? window.Brainfish.HelpWidget.close(e) : console.warn("Brainfish is not initialized. Please call Brainfish.Widgets.init() first."));
}, open: (e) => {
  typeof window != "undefined" && (window.Brainfish && window.Brainfish.HelpWidget ? window.Brainfish.HelpWidget.open(e) : console.warn("Brainfish is not initialized. Please call Brainfish.Widgets.init() first."));
}, toggle: (e) => {
  typeof window != "undefined" && (window.Brainfish && window.Brainfish.HelpWidget ? window.Brainfish.HelpWidget.toggle(e) : console.warn("Brainfish is not initialized. Please call Brainfish.Widgets.init() first."));
} } };
typeof window != "undefined" && (window.Brainfish = { Widgets: { init: j } });
export {
  _ as default
};
//# sourceMappingURL=web.js.map
